import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import FindTeacher from './pages/FindTeacher';
import Teach from './pages/Teach';
import About from './pages/About';
import TeacherProfile from './pages/TeacherProfile';
import PageTransition from './components/PageTransition';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <PageTransition>
            <Home />
          </PageTransition>
        } />
        <Route path="/find-teacher" element={
          <PageTransition>
            <FindTeacher />
          </PageTransition>
        } />
        <Route path="/teach" element={
          <PageTransition>
            <Teach />
          </PageTransition>
        } />
        <Route path="/about" element={
          <PageTransition>
            <About />
          </PageTransition>
        } />
        <Route path="/teachers/:slug" element={
          <PageTransition>
            <TeacherProfile />
          </PageTransition>
        } />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <Box minH="100vh" bg="gray.50">
        <Navbar />
        <AnimatedRoutes />
      </Box>
    </Router>
  );
}

export default App;
